// deps
import React, { memo, ReactElement } from "react";

// internal-deps
import { ScreenTransition } from "@swiggy-private/core-ui";

// interfaces
import { RouteProps } from "@payment-client/interfaces/Router";

// contexts
import { AddSwiggyMoneyContext } from "@payment-client/contexts/AddSwiggyMoneyContext";

// hooks
import useForward from "@payment-client/hooks/UseForward";
import useAddSwiggyMoneyDetails from "@payment-client/hooks/UseAddSwiggyMoneyDetails";

export const SwiggyMoneyPaymentsContainer = memo(function SwiggyMoneyPaymentsContainer(
    props: RouteProps,
): ReactElement | null {
    const addSwiggyMoneyContextValue = useAddSwiggyMoneyDetails();
    const forward = useForward();
    const children =
        Array.isArray(props.children) && props.children.length === 1 ? (
            <ScreenTransition forward={forward}>{props.children[0]}</ScreenTransition>
        ) : (
            props.children
        );

    return (
        <AddSwiggyMoneyContext.Provider value={addSwiggyMoneyContextValue}>{children}</AddSwiggyMoneyContext.Provider>
    );
});
